export const parseErrorMessage = (errorArray) => {
  if (!errorArray || errorArray.length === 0) return "";
  try {
    const errorObj = JSON.parse(errorArray[0]);
    return errorObj.message || errorObj.error || "Unknown error";
  } catch {
    return errorArray[0];
  }
};
